import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    Flex,
} from '@chakra-ui/react';
import { Tooltip } from '@/components/v4';

import { PiPhonePlusLight } from 'react-icons/pi';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import NumbersDropdown from '@/components/forms/new/formikFormFields/NumbersDropdown';
import {
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import { Link } from 'react-router-dom';

const UserPlatformNumberDropdown = ({
    setPlatformUser,
    errors,
    touched,
    darkMode,
    section,
    platformNumbers,
    platform,
    platformIndex,
    isLoading,
    setSelectedNumber,
}) => {
    const userProfiles = platform?.userProfiles || [];

    const handleSelectChange = (item) => {
        setPlatformUser((prev) => {
            const newPlatformUsers = [...prev];
            newPlatformUsers[platformIndex] = {
                ...platform,
                userProfiles: [
                    {
                        ...userProfiles[0],
                        numberID: item.numberID,
                    },
                ],
            };
            return newPlatformUsers;
        });
        setSelectedNumber?.(item);
    };

    const warningLabel = (count) =>
        `Please note this number is currently active on ${count} other platform${
            count > 1 ? 's' : ''
        }. You may still assign the number to this user, however it is recommended to check the other platform assignment and priority for call routing.`;

    const formatOptionLabel = (option) => {
        if (!option.activePlatforms || option.activePlatforms <= 1) {
            return option.telephoneNumber;
        }
        const count = option.activePlatforms - 1;
        return (
            <Flex alignItems="center" gap={1}>
                <Tooltip
                    label={warningLabel(count)}
                    placement="left"
                    hasArrow
                    zIndex={99999999}
                    portalProps={{ appendToParentPortal: false }}>
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <PiPhonePlusLight color="#2e77d6" size={22} />
                    </span>
                </Tooltip>
                {option.telephoneNumber}
            </Flex>
        );
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!errors[`${section}-number`] &&
                touched[errors[`${section}-number`]]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                sx={{
                    ...stackStyling(true),
                    width: '740px',
                    minHeight: '80px',
                }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Number
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Only active numbers are available to assign. Numbers can
                        be updated{' '}
                        <Link color="blue" to="/numbers">
                            here
                        </Link>
                    </Text>
                </Box>
                <Box flex="1">
                    <Field
                        component={NumbersDropdown}
                        id={`${section}-number`}
                        name={`${section}-number`}
                        shownValue="telephoneNumber"
                        currentId={userProfiles[0]?.numberID}
                        handleSelectChange={handleSelectChange}
                        darkMode={darkMode}
                        data={platformNumbers}
                        data-walkthroughid={walkthroughIds.edit.uf}
                        isLoading={isLoading}
                        formatOptionLabel={formatOptionLabel}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Number"
                        ariaLabel={`${section}-number-tooltip`}
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UserPlatformNumberDropdown;
